import { createSlice } from '@reduxjs/toolkit';

// Followed record labels (Erez 11-01) — the followedArtists slice's twin, keyed
// by the label's catalog public id (rows: { label_public_id, label_name, artwork, notify }).
const followedLabelsSlice = createSlice({
    name: 'followedLabels',
    initialState: {
        labels: [],
        followedSet: {}, // labelPublicId -> true
        notifySet: {},   // labelPublicId -> true when the bell is on
        total: 0,
        loaded: false,
        loading: false,
        error: null,
    },
    reducers: {
        setFollowedLabels(state, action) {
            state.labels = action.payload.data;
            state.total = action.payload.total;
            state.loaded = true;
        },
        addLabelFollow(state, action) {
            const label = action.payload;
            state.labels = [label, ...state.labels.filter(l => l.label_public_id !== label.label_public_id)];
            state.total += 1;
            state.followedSet[label.label_public_id] = true;
        },
        removeLabelFollow(state, action) {
            const { labelPublicId } = action.payload;
            state.labels = state.labels.filter(l => l.label_public_id !== labelPublicId);
            state.total = Math.max(0, state.total - 1);
            delete state.followedSet[labelPublicId];
            delete state.notifySet[labelPublicId];
        },
        updateLabelFollowedSet(state, action) {
            for (const [id, on] of Object.entries(action.payload)) {
                if (on) state.followedSet[id] = true;
                else delete state.followedSet[id];
            }
        },
        updateLabelNotifySet(state, action) {
            for (const [id, on] of Object.entries(action.payload)) {
                if (on) state.notifySet[id] = true;
                else delete state.notifySet[id];
            }
        },
        setLabelsLoading(state, action) { state.loading = action.payload; },
        setLabelsError(state, action) { state.error = action.payload; },
        clearFollowedLabels(state) {
            state.labels = [];
            state.followedSet = {};
            state.notifySet = {};
            state.total = 0;
            state.loaded = false;
            state.loading = false;
            state.error = null;
        },
    },
});

export const {
    setFollowedLabels, addLabelFollow, removeLabelFollow, updateLabelFollowedSet, updateLabelNotifySet,
    setLabelsLoading, setLabelsError, clearFollowedLabels,
} = followedLabelsSlice.actions;
export default followedLabelsSlice.reducer;
